import { IoDocumentSharp } from 'react-icons/io5'

import './ProductionReportIcon.css'

// Ícone "documento com P" que leva pra /order/report/:id — usado em toda lista
// que expõe "ver dados do pedido/relatório de produção" (Pedidos, Produção por
// setor, Compras). Centralizado aqui pra qualquer ajuste de cor/tamanho valer
// em todos os lugares de uma vez, em vez de duplicar o mesmo par de classes CSS.
function ProductionReportIcon({ title, onClick }) {
    return (
        <div className="production-report-icon-wrap" title={title} onClick={onClick}>
            <IoDocumentSharp className="production-report-icon-doc" />
            <span className="production-report-icon-letter">P</span>
        </div>
    )
}

export default ProductionReportIcon
